import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Users, UserPlus, Edit2, Trash2, Phone, MapPin, UserCircle,
  Search, Filter, Shirt, CheckCircle, X, Loader
} from 'lucide-react';

// ── Design tokens ─────────────────────────────────────────────────
const T = {
  bg: '#080C18', surface: '#0D1120', surf2: '#111827', surf3: '#161E30',
  border: 'rgba(255,255,255,0.07)', bord2: 'rgba(255,255,255,0.11)',
  text: '#E2E8F0', muted: 'rgba(255,255,255,0.35)',
  blue: '#3B82F6', teal: '#22D3A5', amber: '#FBBF24', red: '#F87171',
  green: '#34D399', purple: '#A78BFA', cyan: '#22D3EE',
  font: "'DM Sans',sans-serif", mono: "'DM Mono',monospace",
};

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&family=DM+Mono:wght@400;500&display=swap');
  @keyframes spin    { to { transform: rotate(360deg); } }
  @keyframes fadeUp  { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
  @keyframes modalIn { from{opacity:0;transform:scale(0.96)} to{opacity:1;transform:scale(1)} }

  .otm-input,.otm-select {
    width:100%; background:rgba(255,255,255,0.05); border:1px solid rgba(255,255,255,0.10);
    border-radius:9px; color:#E2E8F0; font-size:12px; font-family:'DM Sans',sans-serif;
    outline:none; transition:border-color 0.15s,background 0.15s;
  }
  .otm-input  { padding:8px 11px 8px 32px; }
  .otm-select { padding:8px 11px 8px 32px; appearance:none; cursor:pointer; color-scheme:dark; }
  .otm-select option { background:#111827; color:#E2E8F0; }
  .otm-input::placeholder { color:rgba(255,255,255,0.22); }
  .otm-input:focus,.otm-select:focus { border-color:rgba(59,130,246,0.55); background:rgba(59,130,246,0.05); }

  .otm-th { padding:10px 13px; font-size:9px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; color:rgba(255,255,255,0.28); font-family:'DM Sans',sans-serif; border-bottom:1px solid rgba(255,255,255,0.07); white-space:nowrap; background:#111827; }
  .otm-tr { border-bottom:1px solid rgba(255,255,255,0.05); transition:background 0.12s; }
  .otm-tr:last-child { border-bottom:none; }
  .otm-tr:hover td { background:rgba(255,255,255,0.025); }
  .otm-td { padding:10px 13px; vertical-align:middle; }

  .otm-act { display:inline-flex; align-items:center; justify-content:center; width:28px; height:28px; border-radius:7px; border:1px solid; cursor:pointer; transition:all 0.14s; }
  .otm-act-edit   { background:rgba(59,130,246,0.09); color:#60A5FA; border-color:rgba(59,130,246,0.22); }
  .otm-act-edit:hover   { background:rgba(59,130,246,0.18); border-color:rgba(59,130,246,0.42); }
  .otm-act-delete { background:rgba(248,113,113,0.09); color:#F87171; border-color:rgba(248,113,113,0.22); }
  .otm-act-delete:hover { background:rgba(248,113,113,0.18); border-color:rgba(248,113,113,0.42); }

  .otm-btn-add { display:inline-flex; align-items:center; gap:6px; padding:7px 14px; border-radius:9px; border:none; background:linear-gradient(135deg,#3B82F6,#22D3A5); color:#fff; font-family:'DM Sans',sans-serif; font-size:12px; font-weight:700; cursor:pointer; box-shadow:0 4px 12px rgba(59,130,246,0.22); transition:opacity 0.15s; white-space:nowrap; }
  .otm-btn-add:hover { opacity:.88; }
  .otm-btn-reset { display:inline-flex; align-items:center; gap:6px; padding:7px 13px; border-radius:9px; border:1px solid rgba(255,255,255,0.10); background:rgba(255,255,255,0.05); color:rgba(255,255,255,0.45); font-family:'DM Sans',sans-serif; font-size:12px; font-weight:600; cursor:pointer; transition:all 0.15s; white-space:nowrap; }
  .otm-btn-reset:hover { background:rgba(255,255,255,0.09); color:rgba(255,255,255,0.65); }

  .otm-mi,.otm-ms { width:100%; background:rgba(255,255,255,0.05); border:1px solid rgba(255,255,255,0.10); border-radius:9px; color:#E2E8F0; font-size:13px; font-family:'DM Sans',sans-serif; outline:none; transition:border-color 0.15s,background 0.15s; padding:9px 12px 9px 34px; height:40px; }
  .otm-ms { appearance:none; cursor:pointer; color-scheme:dark; }
  .otm-ms option { background:#111827; color:#E2E8F0; }
  .otm-mi::placeholder { color:rgba(255,255,255,0.22); }
  .otm-mi:focus,.otm-ms:focus { border-color:rgba(59,130,246,0.55); background:rgba(59,130,246,0.05); }
  .otm-mi:disabled { opacity:0.4; cursor:not-allowed; }
  .otm-ml { display:block; font-size:10px; font-weight:700; letter-spacing:0.07em; text-transform:uppercase; color:rgba(255,255,255,0.38); margin-bottom:5px; }

  .otm-toggle { display:flex; align-items:center; gap:10px; padding:10px 13px; border-radius:9px; background:rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.08); cursor:pointer; transition:all 0.15s; margin-bottom:14px; }
  .otm-toggle:hover { background:rgba(255,255,255,0.07); border-color:rgba(255,255,255,0.12); }

  .otm-btn-submit { display:inline-flex; align-items:center; gap:7px; padding:9px 20px; border-radius:9px; border:none; background:linear-gradient(135deg,#3B82F6,#22D3A5); color:#fff; font-family:'DM Sans',sans-serif; font-size:13px; font-weight:700; cursor:pointer; box-shadow:0 4px 14px rgba(59,130,246,0.25); transition:opacity 0.15s; }
  .otm-btn-submit:hover:not(:disabled) { opacity:.88; }
  .otm-btn-submit:disabled { opacity:.45; cursor:not-allowed; }
  .otm-btn-cancel { display:inline-flex; align-items:center; gap:6px; padding:9px 16px; border-radius:9px; border:1px solid rgba(255,255,255,0.10); background:rgba(255,255,255,0.05); color:rgba(255,255,255,0.45); font-family:'DM Sans',sans-serif; font-size:13px; font-weight:600; cursor:pointer; transition:all 0.15s; }
  .otm-btn-cancel:hover { background:rgba(255,255,255,0.09); color:rgba(255,255,255,0.65); }

  ::-webkit-scrollbar{width:4px;height:4px}::-webkit-scrollbar-track{background:transparent}::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.10);border-radius:4px}
`;

const AVATAR_COLORS = ['#3B82F6','#22D3A5','#A78BFA','#FBBF24','#F472B6','#22D3EE','#34D399'];
const avatarColor   = (n='') => AVATAR_COLORS[n.charCodeAt(0) % AVATAR_COLORS.length];
const initials      = (n='') => n.trim().split(' ').map(w=>w[0]).slice(0,2).join('').toUpperCase();

const roleCfg = r => ({
  'Field Operator': { color:'#3B82F6', bg:'rgba(59,130,246,0.12)',  border:'rgba(59,130,246,0.28)' },
  'Supervisor':     { color:'#34D399', bg:'rgba(52,211,153,0.12)',  border:'rgba(52,211,153,0.28)' },
  'Technician':     { color:'#22D3EE', bg:'rgba(34,211,238,0.12)', border:'rgba(34,211,238,0.28)' },
}[r] || { color:'rgba(255,255,255,0.35)', bg:'rgba(255,255,255,0.06)', border:'rgba(255,255,255,0.12)' });

const MField = ({ label, icon: Icon, iconColor=T.muted, children }) => (
  <div style={{ marginBottom:14 }}>
    <label className="otm-ml">{label}</label>
    <div style={{ position:'relative' }}>
      {Icon && <Icon size={13} color={iconColor} style={{ position:'absolute',left:11,top:'50%',transform:'translateY(-50%)',pointerEvents:'none',zIndex:1 }} />}
      {children}
    </div>
  </div>
);

// ══════════════════════════════════════════════════════════════════
const TeamMembersList = () => {
  const [teamMembers, setTeamMembers]         = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [showModal, setShowModal]             = useState(false);
  const [editingMember, setEditingMember]     = useState(null);
  const [loading, setLoading]                 = useState(false);
  const [searchTerm, setSearchTerm]           = useState('');
  const [filterRole, setFilterRole]           = useState('');
  const [filterCity, setFilterCity]           = useState('');
  const [formData, setFormData] = useState({
    name:'', phone_number:'', role:'', city:'', uniform_no:'', has_uniform:false
  });

  const fetchTeamMembers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/team-members`);
      setTeamMembers(res.data); setFilteredMembers(res.data);
    } catch (error) { console.error('Failed to fetch team members', error); }
    finally { setLoading(false); }
  };
  useEffect(() => { fetchTeamMembers(); }, []);

  useEffect(() => {
    let f = teamMembers;
    if (searchTerm) f = f.filter(m=>
      m.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      m.phone_number?.includes(searchTerm) ||
      m.uniform_no?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (filterRole) f = f.filter(m=>m.role===filterRole);
    if (filterCity) f = f.filter(m=>m.city===filterCity);
    setFilteredMembers(f);
  }, [searchTerm, filterRole, filterCity, teamMembers]);

  const openModal = (member=null) => {
    setEditingMember(member);
    setFormData(member
      ? { name:member.name||'', phone_number:member.phone_number||'', role:member.role||'', city:member.city||'', uniform_no:member.uniform_no||'', has_uniform:!!member.has_uniform }
      : { name:'', phone_number:'', role:'', city:'', uniform_no:'', has_uniform:false }
    );
    setShowModal(true);
  };
  const closeModal = () => { setShowModal(false); setEditingMember(null); };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type==='checkbox'?checked:value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      editingMember
        ? await axios.post(`${process.env.REACT_APP_API_BASE_URL}/team-members/edit/${editingMember.id}`, formData)
        : await axios.post(`${process.env.REACT_APP_API_BASE_URL}/team-members/add`, formData);
      fetchTeamMembers(); closeModal();
    } catch (error) { console.error('Failed to save team member', error); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this team member?')) return;
    setLoading(true);
    try { await axios.post(`${process.env.REACT_APP_API_BASE_URL}/team-members/delete/${id}`); fetchTeamMembers(); }
    catch (error) { console.error('Failed to delete team member', error); }
    finally { setLoading(false); }
  };

  const handleReset = () => { setSearchTerm(''); setFilterRole(''); setFilterCity(''); };

  return (
    <div style={{ background:T.bg, fontFamily:T.font, color:T.text, padding:'14px 20px' }}>
      <style>{STYLES}</style>

      {/* Page header */}
      <div style={{ background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,marginBottom:18,overflow:'hidden' }}>
        <div style={{ padding:'18px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:14 }}>
          <div>
            <div style={{ fontSize:9,color:T.muted,letterSpacing:'0.18em',marginBottom:5 }}>NOVAA · OPERATIONS</div>
            <div style={{ fontSize:26,fontWeight:800,color:'#fff',letterSpacing:'-0.03em',lineHeight:1 }}>Team Members Management</div>
            <div style={{ fontSize:12,color:T.muted,marginTop:5 }}>Manage your operations team and uniform records</div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:9,color:T.muted,letterSpacing:'0.14em',textTransform:'uppercase',marginBottom:4 }}>Active Members</div>
            <div style={{ fontSize:36,fontWeight:900,color:T.blue,fontFamily:T.mono,lineHeight:1 }}>{teamMembers.length}</div>
          </div>
        </div>
        <div style={{ height:2,background:'linear-gradient(90deg,#3B82F6,#22D3A5,transparent)' }} />
      </div>

      {/* Filters */}
      <div style={{ background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,marginBottom:16,overflow:'hidden' }}>
        <div style={{ padding:'12px 18px',borderBottom:`1px solid ${T.border}`,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:10 }}>
          <div style={{ display:'flex',alignItems:'center',gap:9 }}>
            <div style={{ width:26,height:26,borderRadius:7,background:'rgba(59,130,246,0.12)',border:'1px solid rgba(59,130,246,0.25)',display:'flex',alignItems:'center',justifyContent:'center' }}>
              <Filter size={13} color={T.blue} />
            </div>
            <span style={{ fontSize:13,fontWeight:700,color:T.text }}>Search &amp; Filters</span>
          </div>
          <button className="otm-btn-add" onClick={()=>openModal()}><UserPlus size={12} /> Add Member</button>
        </div>
        <div style={{ padding:'14px 18px',display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(170px,1fr))',gap:12,alignItems:'end' }}>
          <div>
            <div style={{ fontSize:9,fontWeight:700,color:T.muted,letterSpacing:'0.12em',textTransform:'uppercase',marginBottom:6 }}>Search</div>
            <div style={{ position:'relative' }}>
              <Search size={11} color={T.muted} style={{ position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',pointerEvents:'none' }} />
              <input className="otm-input" type="text" placeholder="Name, phone or uniform #…" value={searchTerm} onChange={e=>setSearchTerm(e.target.value)} />
            </div>
          </div>
          <div>
            <div style={{ fontSize:9,fontWeight:700,color:T.muted,letterSpacing:'0.12em',textTransform:'uppercase',marginBottom:6 }}>Role</div>
            <div style={{ position:'relative' }}>
              <UserCircle size={11} color={T.purple} style={{ position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',pointerEvents:'none' }} />
              <select className="otm-select" value={filterRole} onChange={e=>setFilterRole(e.target.value)}>
                <option value="">All Roles</option>
                <option value="Field Operator">Field Operator</option>
                <option value="Supervisor">Supervisor</option>
                <option value="Technician">Technician</option>
              </select>
            </div>
          </div>
          <div>
            <div style={{ fontSize:9,fontWeight:700,color:T.muted,letterSpacing:'0.12em',textTransform:'uppercase',marginBottom:6 }}>City</div>
            <div style={{ position:'relative' }}>
              <MapPin size={11} color={T.amber} style={{ position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',pointerEvents:'none' }} />
              <select className="otm-select" value={filterCity} onChange={e=>setFilterCity(e.target.value)}>
                <option value="">All Cities</option>
                <option value="Karachi">Karachi</option>
                <option value="Lahore">Lahore</option>
                <option value="Islamabad">Islamabad</option>
                <option value="Rawalpindi">Rawalpindi</option>
              </select>
            </div>
          </div>
          <div>
            <button className="otm-btn-reset" onClick={handleReset}><X size={11} /> Reset</button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div style={{ background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,overflow:'hidden' }}>
        {loading ? (
          <div style={{ display:'flex',alignItems:'center',justifyContent:'center',padding:'52px',gap:12 }}>
            <Loader size={20} color={T.blue} style={{ animation:'spin 0.8s linear infinite' }} />
            <span style={{ fontSize:13,color:T.muted }}>Loading…</span>
          </div>
        ) : (
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%',borderCollapse:'collapse' }}>
              <thead>
                <tr>
                  <th className="otm-th">Name</th>
                  <th className="otm-th">Contact</th>
                  <th className="otm-th" style={{ textAlign:'center' }}>Role</th>
                  <th className="otm-th" style={{ textAlign:'center' }}>City</th>
                  <th className="otm-th" style={{ textAlign:'center' }}>Uniform</th>
                  <th className="otm-th" style={{ textAlign:'center' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredMembers.length === 0 ? (
                  <tr><td colSpan={6} style={{ padding:'52px',textAlign:'center',color:T.muted,fontSize:13 }}>
                    <div style={{ fontSize:42,marginBottom:12 }}>👥</div>No members found
                  </td></tr>
                ) : filteredMembers.map(member=>(
                  <tr key={member.id} className="otm-tr">
                    <td className="otm-td">
                      <div style={{ display:'flex',alignItems:'center',gap:10 }}>
                        <div style={{ width:34,height:34,borderRadius:9,background:`${avatarColor(member.name)}20`,border:`1px solid ${avatarColor(member.name)}40`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:avatarColor(member.name),flexShrink:0 }}>
                          {initials(member.name)}
                        </div>
                        <span style={{ fontWeight:600,color:T.text,fontSize:12 }}>{member.name}</span>
                      </div>
                    </td>
                    <td className="otm-td">
                      <div style={{ display:'flex',alignItems:'center',gap:5,fontSize:11,color:T.muted,fontFamily:T.mono }}>
                        <Phone size={10} /> {member.phone_number||'N/A'}
                      </div>
                    </td>
                    <td className="otm-td" style={{ textAlign:'center' }}>
                      {(() => { const c=roleCfg(member.role); return (
                        <span style={{ display:'inline-block',padding:'3px 10px',borderRadius:5,fontSize:10,fontWeight:700,letterSpacing:'0.05em',background:c.bg,color:c.color,border:`1px solid ${c.border}` }}>
                          {member.role||'—'}
                        </span>
                      );})()}
                    </td>
                    <td className="otm-td" style={{ textAlign:'center' }}>
                      <div style={{ display:'flex',alignItems:'center',justifyContent:'center',gap:5,fontSize:11,color:T.muted }}>
                        <MapPin size={10} /> {member.city||'—'}
                      </div>
                    </td>
                    <td className="otm-td" style={{ textAlign:'center' }}>
                      {member.has_uniform ? (
                        <span style={{ display:'inline-flex',alignItems:'center',gap:5,padding:'2px 9px',borderRadius:5,fontSize:10,fontWeight:700,background:'rgba(52,211,153,0.10)',color:T.green,border:'1px solid rgba(52,211,153,0.25)',fontFamily:T.mono }}>
                          <Shirt size={10} /> {member.uniform_no||'Issued'}
                        </span>
                      ) : (
                        <span style={{ display:'inline-block',padding:'2px 9px',borderRadius:5,fontSize:10,fontWeight:700,background:'rgba(255,255,255,0.05)',color:T.muted,border:`1px solid ${T.border}` }}>
                          No Uniform
                        </span>
                      )}
                    </td>
                    <td className="otm-td" style={{ textAlign:'center' }}>
                      <div style={{ display:'flex',gap:6,justifyContent:'center' }}>
                        <button className="otm-act otm-act-edit"   onClick={()=>openModal(member)}><Edit2  size={11} /></button>
                        <button className="otm-act otm-act-delete" onClick={()=>handleDelete(member.id)}><Trash2 size={11} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Add / Edit modal */}
      {showModal && (
        <div style={{ position:'fixed',inset:0,background:'rgba(0,0,0,0.72)',backdropFilter:'blur(4px)',zIndex:1050,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }} onClick={closeModal}>
          <div style={{ background:T.surface,border:`1px solid ${T.bord2}`,borderRadius:16,width:'100%',maxWidth:480,maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 24px 60px rgba(0,0,0,0.7)',animation:'modalIn 0.2s ease',fontFamily:T.font }} onClick={e=>e.stopPropagation()}>

            <div style={{ padding:'15px 20px',borderBottom:`1px solid ${T.border}`,display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0 }}>
              <div style={{ display:'flex',alignItems:'center',gap:9 }}>
                <div style={{ width:28,height:28,borderRadius:8,background:'rgba(59,130,246,0.12)',border:'1px solid rgba(59,130,246,0.25)',display:'flex',alignItems:'center',justifyContent:'center' }}>
                  {editingMember ? <Edit2 size={14} color={T.blue} /> : <UserPlus size={14} color={T.blue} />}
                </div>
                <span style={{ fontSize:14,fontWeight:700,color:T.text }}>{editingMember ? 'Edit Team Member' : 'Add Team Member'}</span>
              </div>
              <button onClick={closeModal} style={{ background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.10)',borderRadius:7,width:28,height:28,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',color:T.muted }}>
                <X size={14} />
              </button>
            </div>

            <div style={{ padding:'16px 20px',overflowY:'auto',flex:1 }}>
              <MField label="Full Name" icon={UserCircle} iconColor={T.blue}>
                <input className="otm-mi" type="text" name="name" required placeholder="Enter name" value={formData.name} onChange={handleChange} />
              </MField>
              <MField label="Phone Number" icon={Phone} iconColor={T.teal}>
                <input className="otm-mi" type="text" name="phone_number" placeholder="Enter phone" value={formData.phone_number} onChange={handleChange} />
              </MField>
              <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 16px' }}>
                <MField label="Role" icon={UserCircle} iconColor={T.purple}>
                  <select className="otm-ms" name="role" value={formData.role} onChange={handleChange} required>
                    <option value="">Select role</option>
                    <option value="Field Operator">Field Operator</option>
                    <option value="Supervisor">Supervisor</option>
                    <option value="Technician">Technician</option>
                  </select>
                </MField>
                <MField label="City" icon={MapPin} iconColor={T.amber}>
                  <select className="otm-ms" name="city" value={formData.city} onChange={handleChange} required>
                    <option value="">Select city</option>
                    <option value="Karachi">Karachi</option>
                    <option value="Lahore">Lahore</option>
                    <option value="Islamabad">Islamabad</option>
                    <option value="Rawalpindi">Rawalpindi</option>
                  </select>
                </MField>
              </div>

              {/* Uniform divider */}
              <div style={{ display:'flex',alignItems:'center',gap:10,margin:'6px 0 14px' }}>
                <div style={{ flex:1,height:1,background:T.border }} />
                <span style={{ fontSize:10,color:T.muted,fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',display:'flex',alignItems:'center',gap:5 }}>
                  <Shirt size={10} /> Uniform Details
                </span>
                <div style={{ flex:1,height:1,background:T.border }} />
              </div>

              {/* Uniform toggle */}
            <label className="otm-toggle" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
  <div style={{ flex: 1 }}>
    <div style={{ fontSize: 12, fontWeight: 700, color: T.text }}>Uniform Issued?</div>
    <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>Toggle if uniform has been assigned</div>
  </div>
  
  {/* Checkbox ke onChange par state update karein */}
  <input 
    type="checkbox" 
    name="has_uniform" 
    checked={formData.has_uniform || false} 
    onChange={(e) => setFormData(p => ({ ...p, has_uniform: e.target.checked }))} 
    style={{ display: 'none' }} 
  />
  
  {/* Visual Toggle UI */}
  <div style={{ width: 36, height: 20, borderRadius: 99, background: formData.has_uniform ? T.teal : 'rgba(255,255,255,0.12)', position: 'relative', transition: 'background 0.2s', flexShrink: 0 }}>
    <div style={{ position: 'absolute', top: 3, left: formData.has_uniform ? 18 : 3, width: 14, height: 14, borderRadius: 99, background: '#fff', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)' }} />
  </div>
</label>

              <MField label="Uniform Number" icon={Shirt} iconColor={T.green}>
                <input
                  className="otm-mi" type="text" name="uniform_no"
                  placeholder="Enter uniform number"
                  value={formData.uniform_no} onChange={handleChange}
                  disabled={!formData.has_uniform}
                  required={formData.has_uniform}
                />
              </MField>
            </div>

            <div style={{ padding:'12px 20px 16px',borderTop:`1px solid ${T.border}`,display:'flex',justifyContent:'flex-end',gap:8,flexShrink:0 }}>
              <button className="otm-btn-cancel" onClick={closeModal}>Cancel</button>
              <button className="otm-btn-submit" onClick={handleSubmit} disabled={loading}>
                {loading
                  ? <><Loader size={13} style={{ animation:'spin 0.8s linear infinite' }} /> Saving…</>
                  : <><CheckCircle size={13} /> {editingMember ? 'Save Changes' : 'Add Member'}</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamMembersList;